import { createSelector } from '@reduxjs/toolkit';

const selectUserForm = (state) => state.userForm;
const selectClickData = (state) => state.clickData;
const selectPaymentForm = (state) => state.paymentForm;
const selectCardImg = (state) => state.cardImg;

export const selectors = {
  vocab: (state) => state.vocab,
  navigatorLocale: (state) => state.navigatorLocale,
  locale: (state) => state.locale,
  clickData: selectClickData,
  showPopup: (state) => state.showPopup,
  showLoader: (state) => state.showLoader,
  successPayment: (state) => state.successPayment,
  popupMsg: (state) => state.popupMsg,
  redirectUrl: (state) => state.redirectUrl,
  getMerchantUrl: (state) => state.getMerchantUrl,
  baseUrl3DS: (state) => state.baseUrl3DS,
  updateClickUrl: (state) => state.updateClickUrl,
  saveClickUrl: (state) => state.saveClickUrl,
  sendClickUrl: (state) => state.sendClickUrl,
  baseUrl: (state) => state.baseUrl,
  userForm: selectUserForm,
  paymentForm: selectPaymentForm,
  getFullName: createSelector(
    [selectUserForm],
    (userForm) => `${userForm.firstName} ${userForm.lastName}`
  ),
  isNotValidUsersForm: createSelector(
    [selectUserForm],
    (userForm) =>
      userForm.firstName.length < 3 ||
      userForm.lastName.length < 3 ||
      userForm.email.length < 6 ||
      userForm.phone.length < 9 ||
      userForm.phone.length > 19 ||
      userForm.city.length < 3 ||
      userForm.address.length < 3 ||
      userForm.zip.length < 3
  ),
  getFormData: createSelector(
    [selectClickData, selectUserForm, selectPaymentForm],
    (clickData, userForm, paymentForm) => ({
      lp: clickData.lp,
      p: clickData.p,
      pub: clickData.pub,
      s: clickData.s,
      r: clickData.r,
      firstName: userForm.firstName,
      lastName: userForm.lastName,
      email: userForm.email,
      phone: userForm.phone,
      city: userForm.city,
      address: userForm.address,
      zip: userForm.zip,
      state: userForm.state,
      cardNumber: paymentForm.cardNumber,
      expirationMonth: paymentForm.expirationMonth,
      expirationYear: paymentForm.expirationYear,
      name: paymentForm.name,
      cvv: paymentForm.cvv,
      host:
        location.hostname === 'localhost'
          ? '247dailydeals.com'
          : location.hostname,
      // host: 'yourbestdailydeal.com',
      cardType: paymentForm.cardType,
    })
  ),
  showCardImg: createSelector(
    [selectCardImg, selectPaymentForm],
    (cardImg, paymentForm) => cardImg[paymentForm.cardType]
  ),
};
